import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import SideNavEditor from 'modules/SideNav/SideNavEditor'
import { useEditorContext } from 'context/EditorContext';
import { fetchSidenav } from 'redux/sidenavSlice'
import { useSelector, useDispatch } from 'react-redux'

const SubwebSideNavEditor = ({ subweb, lang }) => {
  const dispatchRedux = useDispatch()
  const { sidenav, isLoading, error } = useSelector(
    (state) => state.sidenav
  )

  // eslint-disable-next-line no-unused-vars
  const [{ pageSlug }, dispatch] = useEditorContext();

  useEffect(() => {
    dispatchRedux(fetchSidenav({ subweb, lang }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subweb, lang])

  return (
    <SideNavEditor
      initialProps={sidenav}
      isLoading={isLoading}
      error={error}
    />
  )
}

SubwebSideNavEditor.propTypes = {
  subweb: PropTypes.string,
  lang: PropTypes.string,
}

SubwebSideNavEditor.defaultProps = {
  subweb: 'aboutua',
  lang: 'pt',
}

export default SubwebSideNavEditor
